module.exports = __webpack_public_path__ + "img/National Syllabi Vs Global Syllabi.9588eba9.svg";